// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","Error":"Error","ie9":"ie9","content":"content","logo":"logo","searchBtn":"searchBtn","icon":"icon","android":"android","normal":"normal","slim":"slim","errorCode":"errorCode","divider":"divider"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Error/css/Error.styl
// module id = 992
// module chunks = 0